import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HorizontalBarChart, TileFooter, TileCard, } from '@cmd/ui-components';
import { useGetData, formatWholeNumber } from '@cmd/ui-utilities';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import leadsApi, { LeadsDataSource, LeadsResource } from '../../../utils/apis/leadsApiUtils';
import { getTopLeadSourcesLink, getFormattedTopLeadSourcesFromResponse } from './topLeadSourcesUtils';
import './TopLeadSources.scss';
const tileConfigs = {
    [LeadsDataSource.ATKBB]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
    [LeadsDataSource.DDC]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
    [LeadsDataSource.VIN_SOLUTIONS]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_VIN_SOLUTIONS',
            defaultMessage: 'VinSolutions',
        }),
    },
};
const otherLeadSourcesCountFooter = (otherLeadSourcesCount, intl) => (otherLeadSourcesCount ? (_jsx("div", { className: "total-remaining", "data-testid": "ids-horizontal-bar-chart-row-total-remaining", children: intl.formatMessage({
        id: 'TOP_LEAD_SOURCES_OTHER_SOURCES_COUNT',
        defaultMessage: 'Plus {count} Lead{plural} from Other Sources',
    }, {
        count: formatWholeNumber(otherLeadSourcesCount),
        plural: otherLeadSourcesCount === 1 ? '' : 's',
    }) })) : null);
const TopLeadSources = ({ source, limit = 10, 'data-testid': dataTestId }) => {
    const intl = useIntl();
    const testId = dataTestId ? `${dataTestId}-top-lead-sources` : 'ids-top-lead-sources';
    const { sourceMessage } = tileConfigs[source] || { sourceMessage: () => '' };
    const dateRange = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    // ToDo: get rid of this and paramaterize it...
    const params = {
        ...dateRange,
        orgId,
        limit,
    };
    const endpoint = `${source}/${LeadsResource.TOP_SOURCES}`;
    const { data, isLoading, error } = useGetData(() => leadsApi[endpoint].get(params, {
        headers: {
            accept: 'application/vnd.coxauto.v2+json',
        },
    }), params, getFormattedTopLeadSourcesFromResponse);
    const { topLeadSources, remaining, lastUpdatedUTC } = data || {};
    return (_jsxs(TileCard, { title: intl.formatMessage({
            id: 'TOP_LEAD_SOURCES_TILE_TITLE',
            defaultMessage: 'Top Lead Sources',
        }), description: intl.formatMessage({
            id: 'TOP_LEAD_SOURCES_TILE_DESC',
            defaultMessage: 'Lead count based on source',
        }), className: "top-lead-sources", error: !!error, isLoading: isLoading, noData: (topLeadSources || []).length === 0, "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', footer: (_jsx(TileFooter, { sourceLabel: sourceMessage(intl), sourceLink: getTopLeadSourcesLink(source, dateRange), "data-testid": testId, lastUpdated: new Date(lastUpdatedUTC || '') })), children: [_jsx(HorizontalBarChart, { data: topLeadSources || [], "data-testid": testId }), otherLeadSourcesCountFooter(remaining, intl)] }));
};
export default TopLeadSources;
